import { Navigate, generatePath } from 'react-router-dom';

import { NBA_PLAY_LOBBY_EVENTTYPE_FIXTURE } from '@sorare/core/src/constants/__generated__/routes';
import { useLastVisitedEventType } from '@sorare/core/src/hooks/useLastVisitedEventType';

const LobbyPage = () => {
  const defaultFixture = 'ongoing';
  const { lastVisitedEventType } = useLastVisitedEventType();

  return (
    <Navigate
      to={generatePath(NBA_PLAY_LOBBY_EVENTTYPE_FIXTURE, {
        fixture: defaultFixture,
        eventType: lastVisitedEventType,
      })}
      replace
    />
  );
};

export default LobbyPage;
